import React, { useEffect, useState } from 'react';
import ProductNameModal from './ProductNameModal';
import CategoryModal from './CategoryModal';
import SpecificationModal from './SpecificationModal';
import { withPortal } from 'jd-library';
import { useSelector, useDispatch } from 'react-redux';
import LessSpecModal from './LessSpecModal';
import AILoadingModal from './AILoadingModal';
import NoDescription from './NoDescription';
import {clickTrack} from '../../actions/products';

const ValidationModal = props => {
    const {productData,onHidden,specLessThan5,showLoading = false,onSave,togglePaste,updateCount,setReTryAI, noDesc = false } = props;
    const {productName,keywordId} = productData || {};
    const specifications = useSelector(state => state.productSpecification);
    const [specCount,updateSpecCount] = useState(0);
    const dispatch = useDispatch();
    
    const recordImpression = (label) => {
        let li = '',ll = 'digital_catalog';
        switch(label) {
            case 'catReqModal':
                li = 'ai_gen_category_modal';
                break;
            case 'nameReqModal':
                li = 'ai_gen_name_modal';
                break;
            case 'specReqModal':
                li = 'ai_gen_spec_modal';
                break;
            case 'descReqModal':
                li = 'ai_gen_desc_modal';
                break;
            case 'updtProdBtn':
                li='ai_gen_update_name';
                break;
            case 'selCatBtn':
                li='ai_gen_select_category';
                break;
            case 'addSpecBtn':
                li='ai_gen_add_spec';
                break;
            case 'genDescBtn':
                li='ai_gen_add_desc';
                break;
        }
        if(li)
            dispatch(clickTrack({li,ll,userBasedCheck: true}));
    }
    const prodServLabel = productData?.categoryType?.toLowerCase() == "service" ? "Service" : "Product"
    let allProps = {
        productData,
        onHidden,
        onSave,
        nameRef: props?.elementRef?.current['productName'],
        count: props.count,
        openCloseCatSlider: props.openCloseCatSlider,
        recordImpression: recordImpression,
        prodServLabel,
        togglePaste,
        updateCount,
        setReTryAI,
        generateDescription: props.generateDescription
    }

    useEffect(() => {
        if(keywordId) {
            const ignoreField = ['brand', 'country_of_origin', 'price', 'manufacturer', 'manufactured_details', 'importer', 'importers_detail', 'packaging_length', 'packaging_width', 'packaging_height', 'packaging_weight', 'expiry_date'];
            let puvSpecLength =  specifications.savedPuvSpecAttributes.filter(cur => !ignoreField.includes(cur.s_nm) && !!cur.userInput.value).length;
            let sCount = specifications.savedCustomSpecAttributes.length + puvSpecLength; 
            updateSpecCount(sCount);
        }
    },[])

    if(specLessThan5){
        return <LessSpecModal {...allProps} />;
    }else if(productName?.length < 3){
        return <ProductNameModal {...allProps} />;
    }else if(!keywordId) {
        return <CategoryModal {...allProps} />;
    }else if(showLoading) {
        return <AILoadingModal {...allProps} />;
    }else if(noDesc) {
        return <NoDescription {...allProps} />;
    }else if(specCount < 5) {
        return <SpecificationModal {...allProps} />;
    }
    
};

export default withPortal(ValidationModal);